import { Component, OnInit, HostListener } from '@angular/core';
import { LdsUserService } from '../services/lds-user.service';
import {
  Router, NavigationStart, NavigationCancel, NavigationEnd
} from '@angular/router';
import { StorageMap } from '@ngx-pwa/local-storage';
import { DemoAccountService } from '../demo-account.service';
import { IconsService } from '../services/icons.service';
import { CdkMonitorFocus } from '@angular/cdk/a11y';
import { AuthService } from 'src/app/auth.service';
import { WsChatService } from '../lds-websocket-module/ws-chat/ws-chat.service';
import { OverviewService } from '../lds-graph/overview.service';
@Component({
    selector: 'lds-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
    standalone: false
})
export class MainComponent implements OnInit {
  myClass = { 'is-small-screen': window.innerWidth <= 1024 };
  buttonAria = false;
  drawerAria = true;
  drawerClass = null;
  overlayClass = null;
  energyMonitor : boolean = true;
  user;
  deviceSelected;
  isDemo: boolean = false;
  octopusUser: boolean = false ;
  constructor(private overview: OverviewService, user: LdsUserService, private router: Router, private localStorage: StorageMap, private demo: DemoAccountService, private icons: IconsService, private auth: AuthService, private wsChat: WsChatService) {
    this.user = user;
  }

  ngOnInit() {
    this.isDemo = this.demo.isDemo();
    this.energyMonitor = this.checkEnergyMonitor();
    const validUsers = ['56393490-9edc-4661-b0d0-d3524485af62', '5b7110c4-f071-4dea-9049-7fc169014735', '49f7a96c-3393-4562-bb0b-272d369c00ac', '6e25ab5a-4dd3-40c7-b6e8-36d765d7bd56'];
    this.octopusUser = validUsers.includes(this.user.userDetail.user._id) ? true : false;
  }

  buttonClicked() {
    this.buttonAria = true;
    this.drawerAria = false;
    this.drawerClass = 'is-visible';
    this.overlayClass = 'is-visible';
  }

  overlayClicked() {
    this.buttonAria = false;
    this.drawerAria = true;
    this.drawerClass = null;
    this.overlayClass = null;
  }

  navClicked(home?) {
    if (home) {
    }
    if (this.overlayClass === 'is-visible') {
      this.overlayClicked();
    }
  }

  logout() {
    if (this.demo.isDemo()) {
      this.demo.setDemo(false);
    }
    this.localStorage.clear().subscribe(() => {
    });

    this.auth.logout();
    this.wsChat.logout();
    this.overview.clearData();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.myClass = {
      'is-small-screen': event.target.innerWidth <= 1024
    };
  }

  private checkEnergyMonitor(){
    if(!this.user.deviceTypes.hasOwnProperty("Energy Monitor")){
      return false;
    }

    return this.user.deviceTypes["Energy Monitor"] > 0;
  }

}
